import React from 'react'
import api from '../config/axios'

type AuthProps = {
    isAuthenticated: boolean
    dataUser: {
        id: string
        role: string
        company: string
        email: string
        name: string
    }
    authenticate: Function
    signout: Function
}

export const AuthContext = React.createContext({} as AuthProps)

const isValidToken = async () => {
    const token = localStorage.getItem('expotachira_token')
    if (!token) return false

    try {
        // JWT decode & check token validity & expiration.
        const decodedToken = JSON.parse(token)
        const userId = decodedToken.id

        // Validar que el usuario aún existe en la DB
        const isValidUser = await api.get(`/users/${userId}`)

        if (!!isValidUser.data.data) return true
        return false
    } catch (error) {
        console.error('Error validating user:', error)
        return false
    }
}

const getDataAuth = () => {
    const token = localStorage.getItem('expotachira_token')
    // JWT decode & check token validity & expiration.
    if (token) return JSON.parse(token)
    return null
}

const AuthProvider = (props: any) => {
    const [isValidating, setIsValidating] = React.useState(true)
    const [isAuthenticated, makeAuthenticated] = React.useState(false)
    const [dataUser, setDataUser] = React.useState(null)
    function authenticate(data, cb) {
        makeAuthenticated(true)
        setDataUser(null)
        localStorage.setItem('expotachira_token', JSON.stringify(data))
        setTimeout(cb, 100) // fake async
    }
    function signout(cb) {
        makeAuthenticated(false)
        setDataUser(null)
        localStorage.removeItem('expotachira_token')
        setTimeout(cb, 100)
        window.location.href = '/'
    }

    React.useEffect(() => {
        const validateToken = async () => {
            const isValid = await isValidToken()
            if (isValid) {
                makeAuthenticated(true)
                setDataUser(getDataAuth())
                setIsValidating(false)
            } else {
                makeAuthenticated(false)
                setDataUser(null)
                localStorage.removeItem('expotachira_token')
                setIsValidating(false)
            }
        }
        validateToken()
    }, [])

    if (isValidating) {
        return null
    }
    return (
        <AuthContext.Provider
            value={{
                isAuthenticated,
                dataUser,
                authenticate,
                signout,
            }}
        >
            <>{props.children}</>
        </AuthContext.Provider>
    )
}

export default AuthProvider
